module.exports = __webpack_public_path__ + "05b82052e188168e01e076ade60f2c5b.svg";